import styled from 'styled-components';

export const DrawerHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  padding-bottom: 12px;
  border-bottom: 1px solid #f0f0f0;
  margin-bottom: 4px;
`;

export const FieldList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 8px 0;
`;

export const FieldRow = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 10px;
  padding: 10px 12px;
  border-radius: 6px;
  border: 1px solid #f0f0f0;
  background: #fafafa;

  &:hover {
    background: #f5f8ff;
    border-color: #d0e0ff;
  }
`;

export const FieldContent = styled.div`
  flex: 1;
  min-width: 0;
`;

export const FieldLabel = styled.div`
  font-size: 12px;
  color: #8c8c8c;
  margin-bottom: 4px;
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 0.03em;
`;

export const FieldValue = styled.div`
  font-size: 14px;
  color: #262626;
  word-break: break-word;
`;

export const TagsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
`;

export const ConfidenceBadge = styled.span<{ level: 'high' | 'medium' | 'low' }>`
  font-size: 11px;
  font-weight: 500;
  padding: 1px 6px;
  border-radius: 10px;
  white-space: nowrap;
  flex-shrink: 0;

  ${({ level }) =>
    level === 'high' &&
    `
    background: #f6ffed;
    color: #52c41a;
    border: 1px solid #b7eb8f;
  `}

  ${({ level }) =>
    level === 'medium' &&
    `
    background: #fff7e6;
    color: #fa8c16;
    border: 1px solid #ffd591;
  `}

  ${({ level }) =>
    level === 'low' &&
    `
    background: #f5f5f5;
    color: #8c8c8c;
    border: 1px solid #d9d9d9;
  `}
`;

export const DuplicateBanner = styled.div`
  background: #fff7e6;
  border: 1px solid #ffd591;
  border-radius: 6px;
  padding: 10px 12px;
  margin-bottom: 12px;
  font-size: 13px;
  color: #ad6800;
  line-height: 1.5;

  strong {
    display: block;
    margin-bottom: 4px;
  }

  ul {
    margin: 4px 0 0;
    padding-left: 18px;
  }
`;

export const EmptyState = styled.div`
  text-align: center;
  color: #8c8c8c;
  padding: 40px 0;
  font-size: 14px;
`;

export const DrawerFooter = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  padding-top: 16px;
  border-top: 1px solid #f0f0f0;
  margin-top: 8px;
`;
